class CompleteTheLook extends HTMLElement {
  constructor() {
    super();
    this.completeTheLookContainer = this.querySelector(".complete-look-product-container");
  }
  connectedCallback() {
    const bundleContainer = this;
    const completeTheLook = this.completeTheLookContainer.querySelector(".complete-look-product");
    const closePopup = this.querySelector(".close-button-complete-look-product-info");

    this.completeTheLookContainer.addEventListener("mouseenter",function () {
      if(window.matchMedia("(max-width: 1000px)").matches) {
        // Don't handle hover on mobile at all
        return;
      }
      else {
        completeTheLook.classList.remove("hidden");
        var rect = this.getBoundingClientRect();
        var yPos = rect.y - 100;
        var child = this.querySelector('.complete-look-product');
        if (!child) return;
        child.style.position = 'absolute';
        child.style.top = yPos + 'px';
      }
    });
    this.completeTheLookContainer.addEventListener("mouseleave",function () {
      completeTheLook.classList.add("hidden");
    });
    closePopup.addEventListener("click",function (e) {
      // e.stopPropagation();
      if(completeTheLook.classList.contains("hidden")) {
        completeTheLook.classList.remove("hidden");
      }
      else {
        completeTheLook.classList.add("hidden");
      }
    });

    // Handle mobile separately
    // Toggle popup only when heading is clicked
    const heading = this.completeTheLookContainer.querySelector(".complete-look-product-heading");
    heading.addEventListener("click", function (e) {
      if (!window.matchMedia("(max-width: 1000px)").matches) return;

      // e.preventDefault();
      // e.stopPropagation();

      if (completeTheLook.classList.contains("hidden")) {
        completeTheLook.classList.remove("hidden");
      } else {
        completeTheLook.classList.add("hidden");
      }

      bundleContainer.classList.add("mobile-relative");
      bundleContainer.querySelector(".complete-look-product").classList.add("mobile-visibility");
    });   

    const bundle = bundleContainer.querySelectorAll('input[type="radio"]');
    bundle.forEach(select => {
      select.addEventListener('change', function() {
        var selectedOptions = [];
        bundle.forEach(input => {
          if (input.checked) {
            selectedOptions.push(input.getAttribute('data-name'));
          }
        });
        const ldJsonScript = bundleContainer.querySelector('script[data-variant]');
        const productData = JSON.parse(ldJsonScript.textContent);
        var matchedVariant = productData.variants.find(variant => {
          var pass = true;
          for (var i = 0; i < selectedOptions.length; i++) {
            if (selectedOptions.indexOf(variant.options[i]) === -1) {
              pass = false;
              break;
            }
          }
          return pass;
        });
        bundleContainer.querySelector('product-form [name="id"]').value = matchedVariant.id;
      });
    });
  }
}
customElements.define('complete-the-look', CompleteTheLook);

document.querySelectorAll(".product variant-picker .MA-swatch-selector").forEach((input) => {
  input.addEventListener("change", function() {
    showImages();
  });
});


window.showImages = function() {
  
  let swatches = document.querySelectorAll(".product variant-picker .MA-swatch-selector:checked");
  let images = document.querySelectorAll(".product .product-gallery__media");
  let anyMatch = false;
  swatches.forEach(swatch => {
    let swatchAttr = (swatch.getAttribute('data-name')).toLowerCase();
    images.forEach((image, index) => {
      let imageAttr = image.getAttribute("data-media-alt");
      if (imageAttr.includes(swatchAttr)) {
        image.classList.add("MA-active-class");
        image.removeAttribute('hidden', 'true');
        anyMatch = true;
      }
      else{
        image.classList.remove("MA-active-class");
        image.setAttribute('hidden', 'true');
      }
    });
  });
  if(!anyMatch){
    images.forEach((image, index) => {
        image.classList.add("MA-active-class");
        image.removeAttribute('hidden', 'true');
    });
  }
}
window.showImages();



class SliderSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;
    this.space = parseInt(this.slider.dataset.space) || 0;
    this.autoplay = this.slider.dataset.autoplay ? parseInt(this.slider.dataset.autoplay) : null;
    this.navigation = this.slider.dataset.navigation === "true";
    this.pagination = this.slider.dataset.pagination === "true";
    this.loop = this.slider.dataset.loop === "true";
    try {
      this.breakpoints = this.slider.dataset.breakpoints
        ? JSON.parse(this.slider.dataset.breakpoints)
        : null;
    } catch (e) {
      console.warn("Invalid breakpoints format", e);
      this.breakpoints = null;
    }
    this.init();
  }
  init() {
    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: this.space,
      loop: this.loop,
    };
    if (this.pagination) {
      swiperConfig.pagination = {
        el: ".swiper-pagination",
        clickable: true,
      };
    }
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplay,
        disableOnInteraction: false,
      };
    }
    if (this.navigation) {
      swiperConfig.navigation = {
        nextEl: ".swiper-button-cnext",
        prevEl: ".swiper-button-cprev",
      };
    }
    if (this.breakpoints) {
      swiperConfig.breakpoints = this.breakpoints;
    }
    this.swiperInstance = new Swiper(this.slider, swiperConfig);
  }
}
customElements.define("slider-swiper", SliderSwiper);


const container = document.querySelector('safe-stickyy');
if(container){
  container.addEventListener('click', (event) => {
    const clickedItem = event.target.closest('.MA-swatch-selector');
    if (!clickedItem || !container.contains(clickedItem)) return;

      if(clickedItem.classList.contains('MA-swatch-selector')){
        if(screen.width > 999){
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'auto'
            });
            });
          }
      }
    });
  }